import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LuArrowRight } from 'react-icons/lu';
import { Icon } from '../lib/icons';
import styles from './StickyMobileCTA.module.css';

const StickyMobileCTA: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.stickyBar}>
      <Link to="/checkout" className={styles.stickyButton}>
        {t('nav.order')}
        <Icon icon={LuArrowRight} size={14} strokeWidth={2.5} />
      </Link>
    </div>
  );
};

export default StickyMobileCTA;
